import React from 'react';
import { panelsAtom } from '@src/atoms/panels';
import { useAtomValue } from 'jotai';

import Empty from '@images/layout/empty.svg';
import { Focus, ZenWrapper } from './styled';

function ZenPanel() {
  const panels = useAtomValue(panelsAtom);
  const zenMode = Object.values(panels).every(x => !x);

  return zenMode ? (
    <ZenWrapper>
      <Focus>
        <Empty />
      </Focus>
    </ZenWrapper>
  ) : null;
}

export default ZenPanel;
